<template>
  <section class="section container">
    <div class="title is-3 has-text-centered">{{ $t("notes") }}</div>
    <div class="grid is-col-min-10">
      <!-- Card para gestionar notas -->
      <div class="cell" @click="manage_notes">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/256/3039/3039374.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("manage_notes") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Card para gestionar categorías -->
      <div class="cell" @click="manage_categories">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/256/2921/2921226.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("manage_categories") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Card para reportes -->
      <!-- <div class="cell" @click="view_reports">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/256/1055/1055644.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("note_reports") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- Card para búsqueda de notas -->
      <!-- <div class="cell" @click="search_notes">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/256/622/622669.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("search_notes") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </section>
</template>

<script>
import { warning_message } from "@/utils";

export default {
  name: "NoteIndex",
  components: {},
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    manage_notes() {
      this.$router.push({ path: "/note/notes" });
    },
    manage_categories() {
      this.$router.push({ path: "/note/categories" });
    },
    view_reports() {
      warning_message(this.$t("feature_coming_soon"));
    },
    search_notes() {
      this.$router.push({ path: "/note/notes" });
    },
  },
  created() {},
};
</script>

<style scoped>
.grid .cell .card:hover {
  border-radius: 0.5em;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: linear 0.1s;
  transform: scale(1.05, 1.05);
}

.grid .cell .card:active {
  border-radius: 20px;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: ease-out 0.3s;
  transform: scale(1.5, 1.5);
  opacity: 0;
}

.grid .cell .card {
  background-color: rgba(20, 22, 26, 0.4);
}
</style>
